import React from 'react';
import { connect } from 'react-redux';

// Components
import Selection from './selection/selectionComponent';
import Checklist from './checklist/checklistComponent';

import style from './canvas.scss';

const CanvasView = ({ activeStep, stepList }) => {

    if (activeStep === stepList.length - 1 || global.standaloneScene) {
        return (
            <Selection activeStep={activeStep} stepList={stepList} />
        );
    }

    return (
        <div className={style.container}>
            <Selection activeStep={activeStep} stepList={stepList} />
            <div className={style.navigation}>
                <Checklist activeStep={activeStep} stepList={stepList} />
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    activeStep: state.navigation.active,
    stepList: state.navigation.items,
});

const Canvas = connect(
    mapStateToProps,
    null
)(CanvasView);

export default Canvas;
